import React, { FC, useMemo } from 'react';
import styles from './index.module.scss';
import { FilterOrgs, GenericSearchDropdown, IGenericSearchDropdownProps } from 'src/shared';
import BuyerTypesQuickFilter from './BuyerTypesQuickFilter';
import { useApiTenders } from 'src/models/procurements/Tenders/hooks';
import { useTranslation } from 'react-i18next';

export const BuyerQuickFilter: FC<IGenericSearchDropdownProps> = props => {
  const { t } = useTranslation();
  const [{ vars }] = useApiTenders();

  const isChanged = useMemo(
    () => !!vars.buyerOrgIds?.length || !!vars.buyerSearchStrings?.length || !!vars.procuringAgencyTypes?.length,
    [vars.buyerOrgIds?.length, vars.buyerSearchStrings?.length, vars.procuringAgencyTypes?.length]
  );

  return (
    <GenericSearchDropdown
      {...props}
      label={t('ExpiringContracts.buyers')}
      overlay={
        <>
          <FilterOrgs />
          <BuyerTypesQuickFilter />
        </>
      }
      overlayClassName={styles.overlay}
      isChanged={isChanged}
      special={props.special ? props.special : !vars.profileId && isChanged}
    />
  );
};

export default BuyerQuickFilter;
